import dayjs from "dayjs";
import i18n from "../services/i18n";

import { isValidPhoneNumber } from "libphonenumber-js";
import { prune } from "./utility";
import { ValidationMessages } from "./types";

export const errorMessages = {
  [ValidationMessages.Required]: i18n.t("Required"),
  [ValidationMessages.Invalid]: i18n.t("Invalid"),
  [ValidationMessages.Minimum]: i18n.t("Minimum is"),
  [ValidationMessages.Maximum]: i18n.t("Maximum is"),
};

export class CustomValidationArguments {
  keys: Array<string> = [];
  errors: any = {};
  values: any = {};
  allowedKeys: Array<string> = [];
  errorMessage: string = "Required";
  isValid: (data: any) => boolean = (data: any) => true;

  constructor(obj: any) {
    obj && Object.assign(this, prune(obj));
  }
};

export const validateRequiredNotDefault = (
  errors: any,
  required: any,
  values: any,
  defaults: any,
  keys: Array<string>,
  errorMessage: string = "Required",
): any => {
  Object.keys(required).forEach((key) => {
    if (keys.includes(key)) {
      if (Array.isArray(values[key])) {
        values[key].forEach((element: any, index: number) => {
          if (required[key][index]) {
            if (element == null || element === defaults[key][index]) {
              if (errors[key] === undefined) {
                errors[key] = [];
              }

              errors[key][index] = errorMessage;
            }
          }
        });
      } else {
        if (required[key]) {
          if (values[key] == null || values[key] === defaults[key]) {
            errors[key] = errorMessage;
          }
        }
      }
    }
  });

  return errors;
};

export const validateCustomData = ({
  keys,
  errors,
  values,
  allowedKeys,
  errorMessage,
  isValid
}: CustomValidationArguments) => {
  Object.keys(keys).forEach((key) => {
    if (allowedKeys.includes(key) && !isValid(values[key])) {
      errors[key] = errorMessage;
    }
  });

  return errors;
}

export const validateCellphones = (
  args: CustomValidationArguments
) => validateCustomData({
  ...args,
  isValid: (data: string): boolean => !!data && isValidPhoneNumber(data)
});

export const validateBooleansTrue = (
  args: CustomValidationArguments
) => validateCustomData({
  ...args,
  isValid: (data: boolean): boolean => data
});

export const validateDates = (
  args: CustomValidationArguments
) => validateCustomData({
  ...args,
  isValid: (data: any): boolean => data && dayjs(data).isValid()
});

export interface InRangeInfo {
  key: string;
  max?: number;
  min?: number;
}

export const validateNumberInRange = (
  info: InRangeInfo,
  errors: any,
  values: any,
  minErrorMessage: string,
  maxErrorMessage: string,
) => {
  const { key, min, max } = info;

  if (min !== null && min !== undefined && values[key] < min) {
    errors[key] = minErrorMessage + " " + min;
  } else if (max !== null && max !== undefined && values[key] > max) {
    errors[key] = maxErrorMessage + " " + max;
  }
};

export const validateNumbersInRange = (
  infos: Array<InRangeInfo>,
  errors: any,
  values: any,
  allowedKeys: any,
  minErrorMessage: string,
  maxErrorMessage: string,
) => {
  infos.forEach(info => {
    if (allowedKeys.includes(info.key)) {
      validateNumberInRange(
        info,
        errors,
        values,
        minErrorMessage,
        maxErrorMessage,
      );
    }
  });
}